import React from "react";
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

const ClientModalDelete = (props) => {
  const { t: tr } = useTranslation();
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="p-2">
        <div className="modal-title px-2 pt-2">{tr("manage:areYouSureYouWantToDeleteTheClient_142")}</div>
        <div className="modal-body ">{tr("manage:thisActionWillDeleteTheClientsDetailsTheyCannot_143")}</div>
      </Modal.Body>
      <Modal.Footer className="p-2">
        <button type="button" className="btn manage-button manage-red-button" onClick={props.handleClick}>{tr("manage:remove_27")}</button>
        <button type="button" className="btn manage-button manage-teal-button" onClick={props.onHide}>{tr("common:back")}</button>
      </Modal.Footer>
    </Modal>
  );
}
export default ClientModalDelete
